import Paper from '@material-ui/core/Paper';

import React, { Component } from 'react';

import { INotificationsActions } from '../../../../store/notification/actions';
import { IMessageNotification } from '../../../../store/notification/store';
import { IProfileActions } from '../../../../store/user/actions';
import { ISource, IStripeToken, IUserStore } from '../../../../store/user/store';

import Button from '../../../../components/Button';
import CreditCard from '../../../../components/CreditCard';
import CreditCardList from '../../../../components/CreditCardList/CreditCardList';
import { getPic } from '../../../../components/CreditCardList/Utils/getPic';
import { Card, FancyCards } from '../../../../components/FancyCards/FancyCards';
import { PX } from '../../../../contrib/ui';

const ADDPAYMENTHEIGHT = (355 + 28) * Math.max(PX, 0.8); // this view doesnt scale lineally with PX because of stripe...
const BILLINGBASEHEIGHT = (195 + 28) * PX;
const CREDITCARDSIZE = (59 + 14) * PX;

export enum Views {
  'SELECT_PAYMENT',
  'ADD_PAYMENT',
  'DELETE'
}

interface IProps {
  actions: {
    user: IProfileActions;
    notifications: INotificationsActions;
  };
  user: IUserStore;
}

interface IState {
  creditCardFormReady: boolean;
  selectedView: Views;
  selectedSource?: ISource;
}

class PaymentMethods extends Component<IProps, IState> {
  public cardElement: any;
  constructor(props: IProps) {
    super(props);

    this.cardElement = React.createRef();
    this.onCardDelete = this.onCardDelete.bind(this);
    this.onCardDone = this.onCardDone.bind(this);
    this.onCardComplete = this.onCardComplete.bind(this);
    this.onCardSubmit = this.onCardSubmit.bind(this);

    this.state = {
      creditCardFormReady: false,
      selectedView: Views.SELECT_PAYMENT
    };
  }

  public selectView = (cardIndex: number) => () => {
    this.setState({ selectedView: cardIndex });
  };

  public onSelectPayment = (selectedSource: ISource) => () => {
    this.setState({ selectedSource, selectedView: Views.DELETE });
  };

  public onCardDone(): void {
    if (this.cardElement.current) {
      this.cardElement.current.submit();
    }
  }

  public onCardComplete(completed: boolean): void {
    this.setState({ creditCardFormReady: completed });
  }

  public async onCardSubmit(token: IStripeToken): Promise<any> {
    const { actions } = this.props;
    const response = await actions.user.addCustomerSource(token);

    if (response.errors) {
      await actions.notifications.push(({
        status: 'unread',
        text: response.errors.paymentMethods.msg,
        type: 'error'
      } as unknown) as IMessageNotification);
    } else {
      await actions.notifications.push(({
        status: 'unread',
        text: 'Your new payment method was added',
        type: 'success'
      } as unknown) as IMessageNotification);
    }

    this.setState({ selectedSource: token.card, selectedView: Views.SELECT_PAYMENT });
  }

  public async onCardDelete(): Promise<any> {
    const { actions } = this.props;
    if (this.state.selectedSource) {
      const response = await actions.user.deleteCustomerSource(this.state.selectedSource);

      if (response.errors) {
        await actions.notifications.push(({
          status: 'unread',
          text: response.errors.paymentMethods.msg,
          type: 'error'
        } as unknown) as IMessageNotification);
      } else {
        await actions.notifications.push(({
          status: 'unread',
          text: 'Payment method was deleted',
          type: 'success'
        } as unknown) as IMessageNotification);
      }
    }

    this.setState({ selectedView: Views.SELECT_PAYMENT });
  }

  public render(): JSX.Element {
    const { user } = this.props;
    const { selectedSource: source } = this.state;

    const sources = user.customer ? user.customer.sources : [];
    return (
      <>
        <FancyCards selected={this.state.selectedView}>
          <Card height={BILLINGBASEHEIGHT + sources.length * CREDITCARDSIZE} name="payment-list">
            <div className="event-checkout wrapper">
              <Paper elevation={1} className="paper">
                <CreditCardList
                  iconType="delete"
                  onAdd={this.selectView(Views.ADD_PAYMENT)}
                  onSelect={this.onSelectPayment}
                  sources={sources}
                />
              </Paper>
            </div>
          </Card>

          <Card height={ADDPAYMENTHEIGHT} name="payment-form">
            <div className="event-checkout add-payment wrapper">
              <Paper elevation={1} className="paper">
                <h4>ADD A NEW PAYMENT METHOD</h4>
                <CreditCard
                  onComplete={this.onCardComplete}
                  onSubmit={this.onCardSubmit}
                  ref={this.cardElement}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.onCardDone}
                  disabled={!this.state.creditCardFormReady}
                  className="button button-shadow"
                >
                  ADD CREDIT CARD
                </Button>
              </Paper>
            </div>
          </Card>

          <Card height={BILLINGBASEHEIGHT + sources.length * CREDITCARDSIZE} name="payment-delete">
            <div className="event-checkout wrapper">
              <Paper elevation={1} className="paper">
                <div className="credit-card-list delete-card">
                  <h4>ARE YOU SURE YOU WANT TO DELETE THIS PAYMENT METHOD?</h4>
                  {source && (
                    <div className="select-button" style={{ background: 'white' }}>
                      <img src={getPic[source.brand]} alt={`${source.brand} logo`} />
                      <span className="type">Credit / Debit Card</span>
                      <span className="ending">Ending in {source.last4}</span>
                      <span className="space" />
                    </div>
                  )}

                  <Button
                    onClick={this.onCardDelete}
                    color="primary"
                    variant="outlined"
                    fullWidth={true}
                    className="button"
                  >
                    YES, DELETE IT
                  </Button>
                  <Button
                    onClick={this.selectView(Views.SELECT_PAYMENT)}
                    color="primary"
                    variant="contained"
                    fullWidth={true}
                    className="button button-shadow"
                  >
                    CANCEL
                  </Button>
                </div>
              </Paper>
            </div>
          </Card>
        </FancyCards>
      </>
    );
  }
}

export { PaymentMethods };
